import { render, staticRenderFns } from "./pptDetail.vue?vue&type=template&id=06a97707&scoped=true"
import script from "./pptDetail.vue?vue&type=script&lang=js"
export * from "./pptDetail.vue?vue&type=script&lang=js"
import style0 from "./pptDetail.vue?vue&type=style&index=0&id=06a97707&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a97707",
  null
  
)

export default component.exports